import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import DatePicker from "react-datepicker";
/* eslint import/no-webpack-loader-syntax: off */
import "!style-loader!css-loader!react-datepicker/dist/react-datepicker.css";
import styles from "./ChartFilters.css";
import * as actionCreators from "../../../store/analytics/chart-filters/action-creators";
import alertMessageManager from "../../../services/managers/alert-message";
import { DATE_FORMAT, SELECT_EMPTY_VALUE } from "../../../services/managers/constants";
import {
  TOOLTIP_PRODUCT,
  TOOLTIP_END_DATE,
  TOOLTIP_START_DATE,
  TOOLTIP_TIMEZONE,
  TOOLTIP_TIMEZONE_COMMON,
  MSG_ERR_DATE_RANGE_INVALID
} from "../../../services/managers/string-literals";
import CustomDatePickerInput from "../../Common/CustomDatePickerInput/CustomDatePickerInput";

class ChartFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: moment.unix(this.props.selectedDateRangeFrom),
      toDate: moment.unix(this.props.selectedDateRangeTo)
    };
  }

  handleDateChange(which, date) {
    if (which === "from" && this.state.toDate > date) {
      this.setState({ fromDate: date });
      this.props.onSelectedDateRangeChange(which, date);
    } else if (which === "to" && this.state.fromDate < date) {
      this.setState({ toDate: date });
      this.props.onSelectedDateRangeChange(which, date);
    } else {
      alertMessageManager.show("globalAlertError", MSG_ERR_DATE_RANGE_INVALID);
    }
  }

  render() {
    let productDoc = null,
      fromDateDoc = null,
      toDateDoc = null,
      zoneDoc = null,
      productSpecLinkDoc = null;

    productDoc = (
      <select
        className={styles["product-select-box"]}
        value={this.props.selectedProduct}
        onChange={(event) => this.props.onSelectedProductChange(event.target.value)}
        title={TOOLTIP_PRODUCT}>
        {this.props.products.map((product) => (
          <option key={product.ProductCode} value={product.ProductCode}>
            {product.Product} ({product.ProductCode})
          </option>
        ))}
      </select>
    );

    fromDateDoc = (
      <DatePicker
        dateFormat={DATE_FORMAT}
        minDate={moment().subtract(2, "years")}
        maxDate={moment().subtract(1, "days")}
        selected={this.state.fromDate}
        onChange={this.handleDateChange.bind(this, "from")}
        showYearDropdown
        showMonthDropdown
        useShortMonthInDropdown
        placeholderText="From Date"
        customInput={<CustomDatePickerInput tooltip={TOOLTIP_START_DATE} />}
      />
    );

    toDateDoc = (
      <DatePicker
        dateFormat={DATE_FORMAT}
        minDate={moment().subtract(2, "years")}
        maxDate={moment().subtract(1, "days")}
        selected={this.state.toDate}
        showYearDropdown
        showMonthDropdown
        useShortMonthInDropdown
        onChange={this.handleDateChange.bind(this, "to")}
        customInput={<CustomDatePickerInput tooltip={TOOLTIP_END_DATE} />}
      />
    );

    zoneDoc = (
      <select
        className={styles["zone-select-box"]}
        value={this.props.selectedZone}
        onChange={(event) => this.props.onSelectedZoneChange(event.target.value)}
        title={TOOLTIP_TIMEZONE_COMMON}>
        {this.props.zones.map((zone) => (
          <option key={zone.Code} value={zone.Code} title={zone.Name + TOOLTIP_TIMEZONE}>
            {zone.Name} ({zone.Timing})
          </option>
        ))}
      </select>
    );

    productSpecLinkDoc =
      this.props.selectedProduct !== SELECT_EMPTY_VALUE ? (
        <a
          className={styles["contract-btn-link"]}
          href={_.find(this.props.products, { ProductCode: this.props.selectedProduct }).contractspecspage}
          target="_blank">
          {this.props.selectedProduct} Product Contract Specs
        </a>
      ) : null;

    return (
      <div className={styles["chart-filters-component-container"] + " grid"}>
        <div className={"grid__col-md-10 grid__col-sm-10 " + styles["grid-col-section-left"]}>
          <div className={styles["product-control-wrap"]}>
            <label>Product</label>
            {productDoc} <br />
            {productSpecLinkDoc}
          </div>

          <div className={styles["date-control-wrap"]}>
            <label>Start Date</label>
            {fromDateDoc}
          </div>

          <div className={styles["date-control-wrap"]}>
            <label>End Date</label>
            {toDateDoc}
          </div>

          <div className={styles["time-zone-control-wrap"]}>
            <label>Time Zone</label>
            {zoneDoc}
          </div>
        </div>
      </div>
    );
  }
}

ChartFilters.propTypes = {
  products: PropTypes.array.isRequired,
  selectedProduct: PropTypes.string.isRequired,
  selectedDateRangeFrom: PropTypes.number.isRequired,
  selectedDateRangeTo: PropTypes.number.isRequired,

  selectedTradingHour: PropTypes.string.isRequired,
  zones: PropTypes.array.isRequired,
  selectedZone: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  products: state.analytics.products,
  selectedProduct: state.analytics.selectedProduct,
  selectedDateRangeFrom: state.analytics.selectedDateRangeFrom,
  selectedDateRangeTo: state.analytics.selectedDateRangeTo,
  selectedTradingHour: state.analytics.selectedTradingHour,
  zones: state.analytics.zones,
  selectedZone: state.analytics.selectedZone
});

const mapDispatchToProps = (dispatch) => ({
  onSelectedProductChange: (value) => dispatch(actionCreators.onSelectedProductChange({ value })),
  onSelectedDateRangeChange: (which, value) => dispatch(actionCreators.onSelectedDateRangeChange({ which, value })),
  onSelectedZoneChange: (value) => dispatch(actionCreators.onSelectedZoneChange({ value }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChartFilters);



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartFilters/ChartFilters.js